import React from 'react'

// import { Link } from "react-router-dom";
import ContactUs from "./ContactUs.js";

// import './Heading.scss';

function Spealized() {
  return (
    <div>
      <div className="block">
        <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
          Looking for your own specialized honeypot solution?
        </h5>
        <br />
        <p className="block honey-text-common">With HoneyShare, honeypots configured to your needs can be quickly developed and deployed, either to HoneyShare's cloud infrastructure or your own.</p>
        <p className="block honey-text-common">Your captured data remains private to you, you gain access to a highly enriched set of attack data.</p>
        <br />
        <ContactUs text_arg="Contact us for a quote"/>
      </div>
    </div>
  );
}

export default Spealized;
